<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <HelpText>
          <h3>
            Edit Ad Format
          </h3>

          <p>
            Enter the details of the ad format.
          </p>
        </HelpText>
      </div>

      <div class="col-xs-18">
        <div class="panel panel-default">
          <div class="panel-body">
            <LoadingSpinner v-if="loading"/>

            <form v-else @submit.prevent="submit" class="form-horizontal">
              <TextFormGroup
                  v-model="data.name"
                  name="name"
                  label="Name"
                  :error="getError('name')"
              />

              <TextareaFormGroup
                  v-model="data.description"
                  name="description"
                  label="Description"
                  :error="getError('description')"
              />

              <NumberFormGroup
                  v-model="data.price"
                  name="price"
                  label="Price"
                  help-text="The price of the ad format."
                  :error="getError('price')"
              />

              <TextFormGroup
                  v-model="data.size"
                  name="size"
                  label="Size"
                  help-text="The size the ad format in whole pages."
                  :error="getError('size')"
              />

              <RadioFormGroup
                  v-model="data.send_content_reminders"
                  name="send_content_reminders"
                  label="Send Content Reminders"
                  help-text="Send content reminders for this ad format."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('send_content_reminders')"
              />

              <RadioFormGroup
                  v-model="data.is_advertised"
                  name="is_advertised"
                  label="Is Advertised"
                  help-text="Advertise the ad format on the marketing site."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('is_advertised')"
              />

              <TechnicalDescriptionsFormGroup
                  v-model="data.technical_descriptions"
                  :errors="errors"
              />

              <GalleryFormGroup
                  v-model="data.image_id"
                  name="image_id"
                  label="Image"
                  :error="getError('image_id')"
                  :nullable="true"
              />

              <hr>

              <SubmitFormGroup button-class="btn-black"/>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TechnicalDescriptionsFormGroup from '@/components/FormGroups/Horizontal/TechnicalDescriptions'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    GalleryFormGroup,
    HelpText,
    LoadingSpinner,
    NumberFormGroup,
    RadioFormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TechnicalDescriptionsFormGroup,
    TextareaFormGroup,
    TextFormGroup
  },

  mixins: [Errors, Load],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'publicationBasedChannelId', 'adFormatId'],

  data() {
    return {
      data: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/publication-based-ad-formats/' + this.adFormatId),
      ]).then(responses => {
        this.data = responses[0].data.data.attributes

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/publication-based-ad-formats/' + this.adFormatId, this.data)
          .then(response => {
            notify.success('The ad format was saved')

            this.$router.push('/portals/' + this.portal.id + '/publication-based-channels/' + this.publicationBasedChannelId)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
